import { toWords } from "number-to-words";

export const onClearFieldValue = (Formik, fieldNames) => {
  let names = Array.isArray(fieldNames) ? fieldNames : fieldNames?.split(",");
  names?.forEach((element) => {
    Formik.setFieldValue(element, "");
  });
};
export const onSetZeroValue = (Formik, fieldNames) => {
  let names = Array.isArray(fieldNames) ? fieldNames : fieldNames?.split(",");
  names?.forEach((element) => {
    Formik.setFieldValue(element, 0);
  });
};
export const PhPercentageValues = () => {
  return (
    <>
      <option value="40-45">40-45 %</option>{" "}
      <option value="46-50">46-50 %</option>
      <option value="51-55">51-55 %</option>
      <option value="56-60">56-60 %</option>
      <option value="61-65">61-65 %</option>
      <option value="66-70">66-70 %</option>
      <option value="Above 70">Above 70 %</option>
    </>
  );
};

export const MaskAadhaar = (num) => {
  if (!num) {
    return "";
  }
  num = String(num);
  if (!/^\d{12}$/.test(num)) {
    return "";
  }
  return num?.slice(0, 8)?.replace(/\d/g, "X") + num.slice(8);
};
export const CommonhandlePrint = (printId, printTitle) => {
  const printContent = document.getElementById(printId);
  if (!printContent) {
    console.error("Print content element not found.");
    return;
  }
  const printWindow = window.open("", "_blank");
  printWindow.document.write("<html><head><title>" + printTitle + "</title>");
  printWindow.document.write(
    '<link rel="stylesheet" href="path/to/print-styles.css">',
  );
  printWindow.document.write(
    "<style>@media print { body { background-color: #f0f0f0;  }  }</style>",
  );
  printWindow.document.write("</head><body>");
  printWindow.document.write(printContent.innerHTML);
  printWindow.document.write("</body></html>");
  printWindow.document.close();

  printWindow.onload = function () {
    printWindow.print();
    printWindow.onafterprint = function () {
      printWindow.close();
      // Close your modal here
      // For example, if you have a function hideModal() to close the modal:
      // hideModal();
    };
  };
};

export const PrintConte = () => {
  window.print();
};

export const ShowPDF = (imgg) =>
  ConvertFileToBase64(imgg)
    .then((base64Data) => {
      const extractedData = base64Data.split(",")[1];
      const binaryData = atob(extractedData);
      const arrayBuffer = new ArrayBuffer(binaryData.length);
      const uint8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < binaryData.length; i++) {
        uint8Array[i] = binaryData.charCodeAt(i);
      }
      const blob = new Blob([uint8Array], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
    })
    .catch((error) => {
      console.error("Error:", error);
    });
async function ConvertFileToBase64(fileUrl) {
  const response = await fetch(fileUrl);
  const blob = await response.blob();
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
export const numberToWordsIndian = (numStr) => {
  if (!numStr && numStr !== 0) return "";

  const [integerPart, decimalPart] = numStr.toString().split(".");
  let words = toWords(Number(integerPart)).replace(/-/g, " "); // Remove hyphens

  if (decimalPart) {
    const decimalWords = decimalPart
      .split("")
      .map((digit) => toWords(Number(digit)))
      .join(" ");
    words += " point " + decimalWords;
  }

  // Capitalize first letter of each word
  words = words
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

  return words;
};

export const getMaxExperience = (dob) => {
  if (!dob) return 0;

  const today = new Date();
  const birthDate = new Date(dob);

  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  let maxExp = age >= 18 ? age - 18 : 0;

  if (maxExp > 13) maxExp = 13;

  return maxExp;
};

export const calculatePercentage = (secured, total) => {
  if (
    secured === "" ||
    secured === null ||
    secured === undefined ||
    total === "" ||
    total === null ||
    total === undefined
  ) {
    return "";
  }

  const securedNum = Number(secured);
  const totalNum = Number(total);

  if (
    isNaN(securedNum) ||
    isNaN(totalNum) ||
    totalNum === 0
  ) {
    return "";
  }

  // secured marks cannot be greater than total marks
  // if (securedNum > totalNum) {
  //   alert("Marks Secured cannot be greater than Total Marks");
  //   return "";
  // }

  return ((securedNum / totalNum) * 100).toFixed(3);
};

// export const percentageTest = (caste, isPh, isExServiceMen) => {
//   return (value, context) => {
//       if (value) {
//     const num = parseFloat(value);
//     const isNumeric = /^(\d+)(\.\d{1,3})?$/.test(value);

//     if (!isNumeric || num > 100) return false;

//     if (num < 40) {
//       return context.createError({
//         message: "Minimum 40% required to pass",
//       });
//     }

//     let minMarks = 35;
//     if (caste === "OC") {
//       minMarks = 50;
//     } else if (["BC-A", "BC-B", "BC-C", "BC-D", "BC-E"].includes(caste)) {
//       minMarks = 45;
//     } else if (
//       [
//         "SC",
//         "ST",
//         "SC-GR I",
//         "SC-GR II",
//         "SC-GR III",
//         "SC-A",
//         "SC-B",
//         "SC-C",
//       ].includes(caste) ||
//       isPh === "true" ||
//       isExServiceMen === "true"
//     ) {
//       minMarks = 40;
//     }

//     if (num < minMarks) {
//       return context.createError({
//         message: `Minimum ${minMarks}% required`,
//       });
//     }

//     return true;
//   };
// }
// };

export const percentageTest = (caste, isPh, isExServiceMen) => {
  return (value, context) => {
    if (value) {
      const num = parseFloat(value);
      const isNumeric = /^(\d+)(\.\d{1,3})?$/.test(value);

      if (!isNumeric || num > 100) return false;

      if (isPh === "true") {
        if (num < 40) {
          return context.createError({
            message: "Minimum 40% required",
          });
        }
        return true;
      }

      let minMarks = 35;

      if (caste === "OC") {
        minMarks = 50;
      } else if (
        ["BC-A", "BC-B", "BC-C", "BC-D", "BC-E"].includes(caste)
      ) {
        minMarks = 45;
      } else if (
        [
          "SC",
          "ST",
          "SC-GR I",
          "SC-GR II",
          "SC-GR III",
          "SC-A",
          "SC-B",
          "SC-C",
        ].includes(caste)
      ) {
        minMarks = 40;
      }

      if (num < minMarks) {
        return context.createError({
          message: `Minimum ${minMarks}% required`,
        });
      }

      return true;
    }
  };
};